import { Image, LinearProgressBar, Text } from '@wix/design-system'
import { useContent, useNext } from '@wix/funnel-builder-lizard'
import React, { FC, useEffect, useRef } from 'react'

import WixLogo from '../../reusable/icons/WixLogo.svg'
import s from './Transition.scss'
import { TransitionContent } from './typings/Transition.content'

const DEFAULT_TRANSITION_DURATION = 3000
export function easeInOutCubic(t: number) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
}

export const Transition: FC = () => {
  const next = useNext()
  const { content } = useContent<TransitionContent>()
  const transitionDuration = content.transitionDuration ?? DEFAULT_TRANSITION_DURATION
  const logo = new URLSearchParams(window.location.search).get('logo') ?? content.thumbnail.content.src ?? ''
  const [timer, setTimer] = React.useState(0)
  const rafId = useRef<null | number>(null)
  const startTime = useRef(Date.now())
  const progress = 100 * easeInOutCubic(timer / transitionDuration)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      next()
    }, content.transitionDuration ?? DEFAULT_TRANSITION_DURATION)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [])

  useEffect(() => {
    if (timer >= transitionDuration) {
      rafId.current && cancelAnimationFrame(rafId.current)
      return
    }
    const animateCallback = () => {
      const currentTimestamp = Date.now()
      setTimer(currentTimestamp - startTime.current)
      currentTimestamp < transitionDuration && (rafId.current = requestAnimationFrame(animateCallback))
    }

    rafId.current = requestAnimationFrame(animateCallback)

    return () => {
      rafId.current && cancelAnimationFrame(rafId.current)
    }
  }, [timer])

  return (
    <div className={s.page}>
      <WixLogo className={s.wixLogo} />
      <div className={s.content}>
        <div className={s.frame}>
          <Image
            fit="cover"
            height={content.thumbnail.content.height}
            width={content.thumbnail.content.width}
            src={logo}
            alt={content.thumbnail.content.alt}
            borderRadius="6px"
          />
        </div>
        {content.title && <Text className={s.title}>{content.title}</Text>}
        <LinearProgressBar value={progress} />
      </div>
    </div>
  )
}
